module.exports = {
      id: "play-usage",
      viewBox: "0 0 32 32",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#play",
      toString: function () {
        return this.url;
      }
    }